import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SessionTimeout.css';

const SessionTimeout = ({ handleLogout }) => {
    const navigate = useNavigate();

    const handleLoginRedirect = () => {
        handleLogout();
        // Use replace instead of navigate to prevent history stack issues
        window.location.replace('/');
    };

    return (
        <div className="session-timeout-container">
            <div className="session-timeout-box">
                <h1>Session Timed Out</h1>
                <p>Your session has expired due to timeout or inactivity. Please log in again to continue.</p>
                <button onClick={handleLoginRedirect} className="login-button">Go to Login</button>
            </div>
        </div>
    );
};

export default SessionTimeout;